module.exports = __webpack_public_path__ + "img/qtum.1af2d239.svg";